import type { AppKey } from '@/types/appIcon';
import styles from './AppIcon.module.css';

interface AppIconProps {
  app: AppKey;
  size?: number;
  decorative?: boolean;
}

const APP_COLORS: Record<AppKey, string> = {
  chrome: '#4285F4',
  edge: '#0078D7',
  firefox: '#FF7139',
  word: '#2B579A',
  excel: '#217346',
  powerpoint: '#D24726',
  outlook: '#0078D4',
  teams: '#6264A7',
  slack: '#4A154B',
  notion: '#000000',
  vscode: '#007ACC',
  terminal: '#333333',
  unknown: 'var(--color-neutral-400)',
};

export function AppIcon({ app, size = 24, decorative }: AppIconProps) {
  const abbr = app.slice(0, 2).toUpperCase();
  const bg = APP_COLORS[app] ?? APP_COLORS.unknown;

  return (
    <span
      className={styles.icon}
      style={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        backgroundColor: bg,
      }}
      data-testid="app-icon"
      {...(decorative ? { 'aria-hidden': true } : { role: 'img', 'aria-label': app })}
    >
      {abbr}
    </span>
  );
}
